<template>
    <div>
    <div class="site-black-bg min-vh-100 d-flex flex-column mycon">
        <Nav bgColor="#FFFFFF" :inverse="true" />

        <img src="@/assets/The-Cut-Logo.png"
             alt="Atlas Improv Team"
             class="img-fluid mx-auto d-block pt-5"
             style="max-width: 260px;" />

  <div class="mx-auto mt-3" style="max-width: 840px;">
    <div v-if="loading" class="text-center">Loading…</div>
    <div v-else-if="error" class="text-danger text-center">{{ String(error) }}</div>
  </div>

  <!-- Title / Year -->
  <div v-if="cutPage" class="text-center display-1 mx-auto myh1" style="max-width: 560px;">
    The Cut {{ cutPage.year || '' }}
  </div>

  <!-- Main text -->
  <div v-if="cutPage && cutPage.main_text" class=" text-center mx-auto" style="max-width: 840px;" v-text="cutPage.main_text" />

  <!-- Tickets -->
  <div v-if="cutPage && cutPage.show_tickets" class="text-center h2 mx-auto myh1 pt-4" style="max-width: 840px;">Tickets</div>
  <div v-if="cutPage && cutPage.show_tickets && cutPage.ticket_text" class=" text-center mx-auto" style="max-width: 840px;" v-html="cutPage.ticket_text"></div>

  <div v-if="cutPage && cutPage.show_tickets && cutEpisodes && cutEpisodes.length" class=" mx-auto mt-3" style="max-width: 840px;">
    <ul class="list-unstyled text-center m-0 p-0 episodes-list">
      <li v-for="ep in cutEpisodes" :key="ep.id" class="mb-0 py-0">
        <template v-if="ep.active">
          <a :href="ep.link" target="_blank" rel="noopener" class=" text-decoration-underline">{{ ep.display_text }}</a>
        </template>
        <template v-else>
          <span :style="{ textDecoration: ep.expired ? 'line-through' : 'none' }">{{ ep.display_text }}</span>
        </template>
        <!-- <span v-if="ep.start_date" class="d-block small text-muted mt-0 date-line">{{ new Date(ep.start_date).toLocaleString() }}</span> -->
      </li>
    </ul>
  </div>

  <div v-if="cutPage && cutPage.show_panel" class=" text-center h2 mx-auto pt-5 pb-5 myh1 underline" style="max-width: 840px;"> <span class="date">The</span> Cut <span class="date"> Crew</span></div>

  <div v-if="cutPage && cutPage.show_panel && cutPanel" class="container mx-auto mt-3" style="max-width: 720px;">
    <div class="row g-4 align-items-start">
      <!-- Judges column: left on lg+, second on small -->
      <div class="col-12 col-lg-6 order-2 order-lg-1 ">
        <div class="h4 mb-3 d-flex justify-content-center justify-content-lg-start myPanel underline mt-4 mt-lg-0">The Panel</div>
        <ul class="list-unstyled m-0 p-0">
          <li v-if="cutPanel.judge_1" class="mb-3 d-flex flex-column align-items-center align-items-lg-start ">
            <div class="fw-bold judge">{{ cutPanel.judge_1 }}</div>
            <div class="small text-white">{{ cutPanel.title_1 }}</div>
          </li>
          <li v-if="cutPanel.judge_2" class="mb-3 d-flex flex-column align-items-center align-items-lg-start ">
            <div class="fw-bold judge">{{ cutPanel.judge_2 }}</div>
            <div class="small text-white">{{ cutPanel.title_2 }}</div>
          </li>
          <li v-if="cutPanel.judge_3" class="mb-3 d-flex flex-column align-items-center align-items-lg-start">
            <div class="fw-bold judge">{{ cutPanel.judge_3 }}</div>
            <div class="small text-white">{{ cutPanel.title_3 }}</div>
          </li>
        </ul>
      </div>
      <!-- Host column: right on lg+, first on small -->
      <div class="col-12 col-lg-6 order-1 order-lg-2 ">
        <div class="h4 mb-3 d-flex justify-content-center justify-content-lg-start myPanel underline mt-4 mt-lg-0">Host</div>
        <div class="d-flex flex-column align-items-center align-items-lg-start">
          <div class="fw-bold judge">{{ cutPanel.host }}</div>
          <div class="small text-white">{{ cutPanel.host_title }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Crew header -->
  <div v-if="cutPage && cutPage.show_contestants" class=" text-center h2 mx-auto myh1 pt-5" style="max-width: 840px;">Competitors</div>

  <div v-if="cutPage && cutPage.show_contestants" class="mx-auto row justify-content-center" style="max-width: 840px;">
    <div v-for="c in cutContestants" :key="c.id" class="col-12 col-lg-6 text-center mb-4 d-flex flex-column align-items-center">
         <div class=" fw-bold mt-2 d-flex align-items-center justify-content-center">
           <img v-if="c.iscut" :src="`${$API_ASSETS}569f5da6-338b-4fe2-b62a-d7ff3393fc5d.png`" alt="icon left" style="width: 30px; height: auto; margin-right: 8px;" />
           {{ c.name }}
           <img v-if="c.iscut" :src="`${$API_ASSETS}569f5da6-338b-4fe2-b62a-d7ff3393fc5d.png`" alt="icon right" style="width: 30px; height: auto; margin-left: 8px; transform: rotate(180deg);" />
         </div>
      <img
        v-if="(c.iscut && c.cut_headshot && c.cut_headshot.id) || (!c.iscut && c.headshot && c.headshot.id)"
        :src="`${$API_ASSETS}${(c.iscut ? c.cut_headshot.id : c.headshot.id)}.png`"
        alt="Headshot"
        class="img-fluid mx-auto d-block"
        style="width: 250px; height: 250px; object-fit: cover;"
      />

      <div class=" small">{{ c.bio }}</div>
    </div>
    <div v-if="cutContestants.length % 2 !== 0" class="col-12 col-lg-6 text-center mb-4"></div>
  </div>

  <div v-if="cutPage && cutPage.show_tickets" class=" text-center h2 mx-auto" style="max-width: 840px;"></div>
</div>
        <Footer />

    </div>



</template>

<script>
import axios from "axios";
import Nav from "../components/Nav.vue"
import Footer from "@/components/Footer.vue";
import { useHead } from '@vueuse/head';
import { useRoute } from 'vue-router';
export default {
   setup() {
        const route = useRoute();
        useHead({
            title: route.meta.title || 'Atlas Improv',
            meta: [
                { name: 'description', content: route.meta.description || '' }
            ]
        });
        return {};
    },
    components: {
        Nav,
        Footer
    },
    data() {
        return {
            cutPage: null,
            cutEpisodes: [],
            cutContestants: [],
            cutPanel: null,
            loading: false,
            error: null
        }
    },
   methods: {
        async fetchShowData() {
            this.loading = true; this.error = null;
            const url = this.$API_GRAPHQL;
            try {
                const response = await axios.post(url, {
                    query: `
    query{

        CutPage{
            id,
            year,
            main_text,
            ticket_text,
            show_panel,
            show_tickets,
            show_contestants

        }
        cut_episode{
            id
            display_text
            start_date
            link
            active
            expired
        }
        cut_contestant{
        id
        headshot{
            id
        }
        cut_headshot{
            id
        }
        name
        bio
        iscut
    }

      cut_panel{
    judge_1
    title_1
    judge_2
    title_2
    judge_3
    title_3
    host
    host_title
  }

    }
                    `
                }, {
                    headers: {
                        'Authorization': `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
                        'Content-Type': 'application/json'
                    }
                });
                const payload = response?.data?.data?.CutPage;
                this.cutPage = Array.isArray(payload) ? payload[0] : payload || null;
                this.cutEpisodes = response?.data?.data?.cut_episode || [];
                this.cutContestants = response?.data?.data?.cut_contestant || [];
                const panelPayload = response?.data?.data?.cut_panel;
                this.cutPanel = Array.isArray(panelPayload) ? (panelPayload[0] || null) : (panelPayload || null);
            } catch (error) {
                console.error('Error fetching home page data:', error);
                this.error = error;
            } finally {
                this.loading = false;
            }
        },
        getBackgroundColor(index) {
            const colors = ['#017B4A', '#1DB1D9', '#BB4A8C'];
            return { backgroundColor: colors[index % colors.length] };
        }
    },
    created() {
        this.fetchShowData();
    },

}

</script>

<style scoped>
@font-face {
  font-family: 'Bluescreens Bold';
  src: url('@/assets/fonts/Bluescreens/tt-bluescreens-bold-webfont.eot');
  src: url('@/assets/fonts/Bluescreens/tt-bluescreens-bold-webfont.eot?#iefix') format('embedded-opentype'),
       url('@/assets/fonts/Bluescreens/tt-bluescreens-bold-webfont.woff') format('woff'),
       url('@/assets/fonts/Bluescreens/tt-bluescreens-bold-webfont.ttf') format('truetype'),
       url('@/assets/fonts/Bluescreens/tt-bluescreens-bold-webfont.svg#tt-bluescreens-bold-webfont') format('svg');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Uniform Ultra';
  src: url('@/assets/fonts/Ultra/uniform-ultra-webfont.eot');
  src: url('@/assets/fonts/Ultra/uniform-ultra-webfont.eot?#iefix') format('embedded-opentype'),
       url('@/assets/fonts/Ultra/uniform-ultra-webfont.woff') format('woff'),
       url('@/assets/fonts/Ultra/uniform-ultra-webfont.ttf') format('truetype'),
       url('@/assets/fonts/Ultra/uniform-ultra-webfont.svg#uniform-ultra-webfont') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Uniform Condensed Medium';
  src: url('@/assets/fonts/Condensed-Medium/uniformcondensed-medium-webfont.eot');
  src: url('@/assets/fonts/Condensed-Medium/uniformcondensed-medium-webfont.eot?#iefix') format('embedded-opentype'),
       url('@/assets/fonts/Condensed-Medium/uniformcondensed-medium-webfont.woff') format('woff'),
       url('@/assets/fonts/Condensed-Medium/uniformcondensed-medium-webfont.ttf') format('truetype'),
       url('@/assets/fonts/Condensed-Medium/uniformcondensed-medium-webfont.svg#uniformcondensed-medium-webfont') format('svg');
  font-weight: normal;
  font-style: normal;
}
.mycon {
	margin: 0;
	padding: 0;
	text-align: left;
/*	font: 15px Georgia, "Times New Roman", Times, serif;*/
	/*font: 16px "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif;*/
	font: 18px "Uniform Condensed Medium", HelveticaNeue, "Helvetica Neue", sans-serif;
	text-transform: uppercase;
	line-height: 1.50;
	color: #d8cdbe;
	width: 100%;
	height: 100%;
}
.myh1 {
    font-family: "Uniform Ultra", HelveticaNeue, "Helvetica Neue", sans-serif;
    font-size: 45px;
}

.judge {
    font-family: "Uniform Ultra", HelveticaNeue, "Helvetica Neue", sans-serif;
    font-size: 25px;
}

.Section-Header {
	padding-left: 20px;
	padding-right: 20px;
	text-align: center;
	display: block;
	text-decoration: underline;
}
.myPanel{
    font-family: "Uniform Ultra", HelveticaNeue, "Helvetica Neue", sans-serif;
    font-size: 30px;
    line-height: 1.0;
    color: #d8cdbe;
}
.date {
	font-family: "Bluescreens Bold", HelveticaNeue, "Helvetica Neue", sans-serif;
}

.underline {
  text-decoration: underline;
}

.episodes-list li { margin-bottom: 2px !important; }
.episodes-list li + li { margin-top: 2px; }
.episodes-list a, .episodes-list span { line-height: 1.1; }
.episodes-list .date-line { margin-top: 0.1rem; }
</style>
